import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { STORE_HOME_URL } from '../../data/storeCatalog';

const footerLinks = {
  products: [
    { name: 'Patinetes electricos', href: '/patinetes-electricos' },
    { name: 'Bicicletas electricas', href: '/bicicletas-electricas' },
    { name: 'Accesorios y recambios', href: '/accesorios-recambios' },
    { name: 'Soporte', href: '/soporte' },
  ],
  company: [
    { name: 'Sobre Zwheel', href: '/sobre-zwheel' },
    { name: 'Tecnologia', href: '/technology' },
    { name: 'Blog', href: '/blog' },
    { name: 'Contacto', href: '/contacto' },
  ],
  support: [
    { name: 'Centro de soporte', href: '/soporte' },
    { name: 'Matrículas VMP', href: '/matricula' },
    { name: 'Seguros VMP', href: '/seguros' },
    { name: 'Red oficial de SAT', href: '/soporte/red-servicio-tecnico' },
    { name: 'Buscar recambios', href: '/accesorios-recambios' },
    { name: 'Hablar con el equipo', href: '/contacto' },
    { name: 'Tienda oficial', href: STORE_HOME_URL, external: true },
  ],
  legal: [
    { name: 'Aviso legal', href: '/legal/terms' },
    { name: 'Politica de privacidad', href: '/legal/privacy' },
    { name: 'Politica de cookies', href: '/legal/cookies' },
    { name: 'Condiciones de garantia', href: '/legal/condiciones-garantia' },
  ],
};

// Social Icons Components
const LinkedInIcon = () => (
  <svg aria-hidden="true" className="e-font-icon-svg e-fab-linkedin h-5 w-5" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
  </svg>
);

const YouTubeIcon = () => (
  <svg aria-hidden="true" className="e-font-icon-svg e-fab-youtube h-5 w-5" viewBox="0 0 576 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"></path>
  </svg>
);

const FacebookIcon = () => (
  <svg aria-hidden="true" className="e-font-icon-svg e-fab-facebook h-5 w-5" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"></path>
  </svg>
);

const InstagramIcon = () => (
  <svg aria-hidden="true" className="e-font-icon-svg e-fab-instagram h-5 w-5" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
  </svg>
);

const TikTokIcon = () => (
  <svg aria-hidden="true" className="e-font-icon-svg e-fab-tiktok h-5 w-5" viewBox="0 0 448 512" xmlns="http://www.w3.org/2000/svg">
    <path d="M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"></path>
  </svg>
);

const socialLinks = [
  { name: 'LinkedIn', icon: LinkedInIcon, href: 'https://es.linkedin.com/company/zwheel' },
  { name: 'YouTube', icon: YouTubeIcon, href: 'https://www.youtube.com/@zwheeloficial' },
  { name: 'Facebook', icon: FacebookIcon, href: 'https://www.facebook.com/zwheelpatinetes' },
  { name: 'Instagram', icon: InstagramIcon, href: 'https://www.instagram.com/_zwheel/' },
  { name: 'TikTok', icon: TikTokIcon, href: 'https://www.tiktok.com/@zwheeloficial' },
];

export function Footer() {
  return (
    <footer className="bg-white text-zwheel-black">
      <div className="container-max section-padding">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 text-center md:text-left">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <Link to="/" className="mb-4 block flex justify-center md:justify-start">
              <img
                src="/cropped-Logo-negro-Zwheel_ok.png"
                alt="ZWHEEL"
                className="h-8 w-auto"
              />
            </Link>
            <p className="text-zwheel-gray-600 mb-6 text-sm leading-relaxed">
              Diseno, tecnologia y rendimiento para vivir la movilidad electrica con libertad, seguridad y caracter Zwheel.
            </p>
            <div className="space-y-2 text-sm text-zwheel-gray-600">
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <MapPin className="h-4 w-4 flex-shrink-0" />
                <span>Calle Riera Roja 12, 08830 Sant Boi de Llobregat (Barcelona) ESPAÑA</span>
              </div>
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <Phone className="h-4 w-4 flex-shrink-0" />
                <span>+34 936 675 437</span>
              </div>
              <div className="flex items-center justify-center md:justify-start space-x-2">
                <Mail className="h-4 w-4 flex-shrink-0" />
                <span>info@zwheel.com</span>
              </div>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="font-semibold mb-4">Productos</h3>
            <ul className="space-y-2">
              {footerLinks.products.map((link) => (
                <li key={link.name} className="flex justify-center md:justify-start">
                  <Link
                    to={link.href}
                    className="text-zwheel-gray-600 hover:text-zwheel-black transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4">Sobre ZWHEEL</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.name} className="flex justify-center md:justify-start">
                  <Link
                    to={link.href}
                    className="text-zwheel-gray-600 hover:text-zwheel-black transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold mb-4">Soporte Técnico</h3>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.name} className="flex justify-center md:justify-start">
                  {'external' in link && link.external ? (
                    <a
                      href={link.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-zwheel-gray-600 hover:text-zwheel-black transition-colors text-sm"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-zwheel-gray-600 hover:text-zwheel-black transition-colors text-sm"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.name} className="flex justify-center md:justify-start">
                  <Link
                    to={link.href}
                    className="text-zwheel-gray-600 hover:text-zwheel-black transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Social Links & Copyright */}
        <div className="border-t border-zwheel-gray-200 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex justify-center md:justify-start space-x-6">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-zwheel-gray-500 hover:text-zwheel-black transition-colors"
                  aria-label={social.name}
                >
                  <social.icon />
                </a>
              ))}
            </div>
            <p className="text-zwheel-gray-500 text-sm text-center">
              © 2024 ZWHEEL. Todos los derechos reservados.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
